import { Button } from '@shared/components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowDown } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { ShipmentsFilters } from '../../adapters/ShipmentsApiAdapter';
import { useExportInvoicesOrders } from '../../hooks/useExportInvoicesOrders';

interface Props {
  filters: ShipmentsFilters;
  selectedColumns?: string[];
}

export const DownloadExcelButton: React.FC<Props> = ({ filters, selectedColumns }) => {
  const { t } = useTranslation('invoicesOrdersModule');
  const { exportEligibleShipments, isExporting } = useExportInvoicesOrders();

  const handleExport = () => {
    exportEligibleShipments(filters, selectedColumns);
  };

  return (
    <Button
      onClick={handleExport}
      disabled={isExporting}
      type="button"
      size="sm"
      variant="outline"
      className={`!py-[9px] !px-2 !text-icons transition-opacity duration-200 ${
        isExporting ? 'opacity-60 pointer-events-none' : ''
      }`}
      data-testid="export-excel-button"
    >
      <FontAwesomeIcon icon={faFileArrowDown} />
    </Button>
  );
};
